import qs from 'qs';
import ValidationError from "../../classes/ValidationError";
import Model from "../../classes/model/Model";
import User from "./User";
import Client from "./Client";

/**
 * @property {int} id
 * @property {int} client_id
 * @property {int} user_id
 * @property {int} type_id
 * @property {int} end_at
 * @property {string} text
 * @property {int} complete
 * @property {int} complete_at
 *
 * @property {int} created_by
 * @property {int} updated_by
 * @property {int} created_at
 * @property {int} updated_at
 *
 * @property {Client} client
 * @property {TaskComment} comments
 * @property {User} responsible
 * @property {User} creator
 * @property {User} updater
 */
export default class Task extends Model {

    relations() {
        return {
            client: {class: Client, many: false},
            comments: {class: Client, many: true},
            creator: {class: User, many: false},
            updater: {class: User, many: false},
        };
    }

    static getList(filter = {}, page = 1, sort = undefined, perPage = 25,  extraFields = []) {

        return Task.getAxios().get(Task.getUrl('task/list'), {
            params: {
                page: page,
                'per-page': perPage,
                filter: filter,
                sort: sort,
                expand: extraFields.length > 0 ? extraFields.join(',') : undefined,
            },
            paramsSerializer: params => qs.stringify(params),
        }).then((response) => {
            let data = [];
            for (let task of response.data) {
                data.push(new Task(task));
            }
            return {data, headers: response.headers};
        });
    }

    static getListPersonal(filter = {}, page = 1, sort = undefined, perPage = 25,  extraFields = []) {

        return Task.getAxios().get(Task.getUrl('task/list-personal'), {
            params: {
                page: page,
                'per-page': perPage,
                filter: filter,
                sort: sort,
                expand: extraFields.length > 0 ? extraFields.join(',') : undefined,
            },
            paramsSerializer: params => qs.stringify(params),
        }).then((response) => {
            let data = [];
            for (let task of response.data) {
                data.push(new Task(task));
            }
            return {data, headers: response.headers};
        });
    }

    static getById(id, extraFields = []) {

        return this.getAxios().get(this.getUrl('task/get-by-id'), {
            params: {
                id: id,
                expand: extraFields.length > 0 ? extraFields.join(',') : undefined,
            },
        }).then(({data}) => {
            return new Task(data);
        });
    }

    static getByIdForModal(id, extraFields = []) {

        return this.getAxios().get(this.getUrl('task/get-by-id-for-modal'), {
            params: {
                id: id,
                expand: extraFields.length > 0 ? extraFields.join(',') : undefined,
            },
        }).then(({data}) => {
            return new Task(data);
        });
    }

    static taskLidToClientVisit(id, comment){
        return this.getAxios().post(this.getUrl('task/task-lid-to-client-visit'), {
            taskId:id,
            comment:comment
        }).then(({data}) => {
            console.log(data);
            return data.success;

        }).catch(error => {
            if (error.response) {
                console.error('Server Error:', error.response.status, error.response.data);
            } else if (error.request) {
                console.error('No Response:', error.request);
            } else {
                console.error('Error:', error);
            }
        });
    }

    static taskLidToClientControl(id, comment){
        return this.getAxios().post(this.getUrl('task/task-lid-to-control'), {
            taskId:id,
            comment:comment
        }).then(({data}) => {
            console.log(data);
            return data.success;
        }).catch(error => {
            if (error.response) {
                console.error('Server Error:', error.response.status, error.response.data);
            } else if (error.request) {
                console.error('No Response:', error.request);
            } else {
                console.error('Error:', error);
            }
        });
    }

    static taskLidToClientRefusal(id, comment){
        return this.getAxios().post(this.getUrl('task/task-lid-to-refusal'), {
            taskId:id,
            comment:comment
        }).then(({data}) => {
            console.log(data);
            return data.success;
        }).catch(error => {
            if (error.response) {
                console.error('Server Error:', error.response.status, error.response.data);
            } else if (error.request) {
                console.error('No Response:', error.request);
            } else {
                console.error('Error:', error);
            }
        });
    }

    static taskLidToPotential(id, comment){
        return this.getAxios().post(this.getUrl('task/task-lid-to-potential'), {
            taskId:id,
            comment:comment
        }).then(({data}) => {
            console.log(data);
            return data.success;
        }).catch(error => {
            if (error.response) {
                console.error('Server Error:', error.response.status, error.response.data);
            } else if (error.request) {
                console.error('No Response:', error.request);
            } else {
                console.error('Error:', error);
            }
        });
    }

    static taskLidOrderedComplete(id, comment){
        return this.getAxios().post(this.getUrl('task/task-lid-ordered-complete'), {
            taskId:id,
            comment:comment
        }).then(({data}) => {
            console.log(data);
            return data.success;
        }).catch(error => {
            if (error.response) {
                console.error('Server Error:', error.response.status, error.response.data);
            } else if (error.request) {
                console.error('No Response:', error.request);
            } else {
                console.error('Error:', error);
            }
        });
    }

    static taskLidOrderedCancel(id, comment){
        return this.getAxios().post(this.getUrl('task/task-lid-ordered-cancel'), {
            taskId:id,
            comment:comment
        }).then(({data}) => {
            console.log(data);
            return data.success;
        }).catch(error => {
            if (error.response) {
                console.error('Server Error:', error.response.status, error.response.data);
            } else if (error.request) {
                console.error('No Response:', error.request);
            } else {
                console.error('Error:', error);
            }
        });
    }

    static taskLidOrderedMissComplete(id, comment){
        return this.getAxios().post(this.getUrl('task/task-lid-ordered-miss-complete'), {
            taskId:id,
            comment:comment
        }).then(({data}) => {
            console.log(data);
            return data.success;
        }).catch(error => {
            if (error.response) {
                console.error('Server Error:', error.response.status, error.response.data);
            } else if (error.request) {
                console.error('No Response:', error.request);
            } else {
                console.error('Error:', error);
            }
        });
    }

    static taskFirstToActive(id, comment){
        return this.getAxios().post(this.getUrl('task/task-first-to-active'), {
            taskId:id,
            comment:comment
        }).then(({data}) => {
            console.log(data);
            return data.success;
        }).catch(error => {
            if (error.response) {
                console.error('Server Error:', error.response.status, error.response.data);
            } else if (error.request) {
                console.error('No Response:', error.request);
            } else {
                console.error('Error:', error);
            }
        });
    }

    static taskFirstToPovtornoeProbnoe(id, comment){
        return this.getAxios().post(this.getUrl('task/task-first-to-povtornoe-probnoe'), {
            taskId:id,
            comment:comment
        }).then(({data}) => {
            console.log(data);
            return data.success;
        }).catch(error => {
            if (error.response) {
                console.error('Server Error:', error.response.status, error.response.data);
            } else if (error.request) {
                console.error('No Response:', error.request);
            } else {
                console.error('Error:', error);
            }
        });
    }

    create() {
        return Task.getAxios().post(this.getUrl('task/create'), this.getValues()).then(({data}) => {
            if (data.success === false) {
                throw new ValidationError(data.errors);
            }
            this.id = data.id;
            return true;
        });
    }

    update() {
        if (!this.id) {
            throw new Error('id not set');
        }

        return Task.getAxios().post(this.getUrl('task/update'), this.getValues()).then(({data}) => {
            if (data.success === false) {
                throw new ValidationError(data.errors);
            }
            return true;
        })
    }

    close() {
        if (!this.id) {
            throw new Error('id not set');
        }
        return Task.getAxios().post(this.getUrl('task/close'), {id: this.id}).then(({data}) => {
            if (data.success === false) {
                throw new Error(data.errors);
            }
            this.complete = 1;
            this.complete_at = data.complete_at;
            return true;
        });
    }

    getHelp() {
        let text = '';

        if (this.type_id === 1) {
            text = 'КОГДА ВАМ УДОБНО ПОСЕЩАТЬ ЗАНЯТИЯ?ДНЕМ ИЛИ ВЕЧЕРОМ?<br>Предложить максимально удобную  и малочисленную группу. Рассказать о том, что у нас универсальные абонементы и по одной карте можно ходить на разные занятие + о скидке для постоянных клиентов.';
        }
        if (this.type_id === 3) {
            text = 'КАК У ВАС ПРОШЛО ЗАНЯТИЕ? КАК ВАМ ПЕДАГОГ? ЗАПИСАТЬ ВАС НА ЗАНЯТИЕ?<br>Если человеку не понравилось занятие - узнать причину и предложить другой вариант занятий(другого педагога) - донести до управляющего если эта причина связана с педагогом.';
        }
        if (this.type_id === 4) {
            text = 'Как проходят ваши тренировки? Как ваши успехи? Все ли вам нравится? (предложить человеку совмещать с другими тренировками) Удачи вам на занятиях. До встречи!';
        }
        if (this.type_id === 5 || this.type_id === 6 || this.type_id === 7) {
            text = 'Почему перестали к нам ходить? если у человека не все занятия исхожены - сообщить, что при покупке следующего абонемента мы ему их добавим - записать на занятие.';
        }

        return text;
    }

}
